import PortalIdParser from 'PortalIdParser';
import apiClient from 'hub-http/clients/noAuthApiClient';
import quickFetch from 'quick-fetch';
import { createChirpAvroRpcClientV1, createRpcClientV2 } from 'rpc-client-utils';
// @ts-expect-error No types
import isMobile from 'isMobile';
import { createViewSessionRpc, finishPageRpc, nextPageRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsViewSessionPublicService';
const baseUrl = 'presentations/v1/revisit';

// Fetch transport for the CHIRP client that keeps the request alive during
// page unload (`keepalive: true`), so finish events fired on tab close aren't
// dropped. Resolves the gateway path to an absolute URL via quick-fetch and
// includes credentials to mirror hub-http's noAuth-with-credentials stack.
const keepaliveFetchClient = (input, init) => {
  const url = typeof input === 'string' ? quickFetch.getApiUrl(input) : input;
  return fetch(url, Object.assign({}, init, {
    keepalive: true,
    credentials: 'include'
  }));
};
export function createActivity(presentationId, accessId, viewer) {
  return apiClient.post(`${baseUrl}/async/${presentationId}`, {
    query: {
      portalId: PortalIdParser.get(),
      accessId
    },
    data: viewer
  });
}
export const createActivityCHIRP = async ({
  accessId,
  documentId,
  viewer
}) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  const response = await rpcClient.call(createViewSessionRpc, {
    request: {
      accessId,
      sharedLinkId: documentId,
      userAgent: navigator.userAgent,
      viewer
    }
  });
  return response;
};

// returns 204 No Content
export function viewPage(presentationId, accessId, activityId, pageIndex) {
  return apiClient.post(`${baseUrl}/${presentationId}/${activityId}/page/${pageIndex}`, {
    query: {
      portalId: PortalIdParser.get(),
      accessId
    }
  });
}
export const startPageCHIRP = async ({
  accessId,
  activityId,
  documentId,
  pageNumber,
  userId
}) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  const response = await rpcClient.call(nextPageRpc, {
    request: {
      accessId,
      mobile: !!isMobile.any,
      pageNumber,
      sharedLinkId: documentId,
      userId,
      viewSessionId: activityId
    }
  });
  return response;
};

// returns 204 No Content
//
// Only ever dispatched from `window.onbeforeunload`, so it always uses a
// `keepalive: true` fetch to survive page unload (an XHR would be cancelled).
export function finishActivity(presentationId, accessId, activityId) {
  const query = new URLSearchParams({
    portalId: String(PortalIdParser.get())
  });
  if (accessId !== null && accessId !== undefined) {
    query.set('accessId', accessId);
  }

  // Resolve to the app API passthrough host (`https://app.hubspot.com/api/...`)
  // that serves this REST endpoint via `apiPassthrough: true`. `getApiUrl`
  // concatenates origin + path, so the leading slash is required.
  const url = quickFetch.getApiUrl(`/${baseUrl}/${presentationId}/${activityId}/finish?${query.toString()}`, true);
  return fetch(url, {
    method: 'POST',
    keepalive: true,
    credentials: 'include'
  });
}
export const finishPageCHIRP = async ({
  accessId,
  activityId,
  documentId,
  documentClosing,
  pageNumber,
  viewer,
  keepalive = false
}) => {
  const request = {
    accessId,
    pageNumber,
    sharedLinkId: documentId,
    timestamp: Date.now(),
    viewer,
    viewSessionId: activityId,
    documentClosing
  };

  // On tab close, route through the CHIRP fetch transport with keepalive so
  // the request completes even as the page unloads. Everything else (gateway
  // path, fingerprint header, serialization, response parsing) is still handled
  // by the generated client.
  if (keepalive) {
    return createChirpAvroRpcClientV1({
      fetchClient: keepaliveFetchClient
    }).call(finishPageRpc, {
      request
    });
  }
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  const response = await rpcClient.call(finishPageRpc, {
    request
  });
  return response;
};